module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_1_de-5fd9ec1d78e8c2c928178ac98a31f618.png";